import { useSelector } from 'react-redux';
import { Box, Container } from '@mui/material';
import PartnerLogoFooter from './PartnerLogoFooter';
import config from '../../api/config';
import CoachTrialConvertForm from './CoachTrialConvertForm';
import useScreenDimensions from '../../common/hooks/useScreenDimensions';
import BlackTHTrainHeroicLogo from '../../common/assets/BlackTHTrainHeroicLogo';

const testimonialDescription =
    'Over the past couple of years I’ve tested different platforms, gathered client feedback, and experimented with different ways to deliver my coaching. After all of that, I’ve come full circle and realized TrainHeroic is still the best platform for delivering high-quality training and coaching.';

const testimonialAuthor = 'Ruben Cadet: Kettlebell Coach and Firefighter';

const MOBILE_DEVICE_WIDTH = 768;
const MOBILE_WELCOME_URL = 'https://www.trainheroic.com/welcome/';

export default function ConvertCoachTrialAccount() {
    const isAuthenticated = useSelector((state: any) => state.authentication?.isAuthenticated);
    const { width } = useScreenDimensions();

    if (isAuthenticated) {
        if (width > MOBILE_DEVICE_WIDTH) {
            window.location.replace(config.URL_COACHAPP);
        } else {
            window.location.replace(MOBILE_WELCOME_URL);
        }
        return null;
    }

    return (
        <Box className="outer-container signup-form convert-coach-trial-page">
            <Box className="signup-header">
                <BlackTHTrainHeroicLogo className={undefined} />
            </Box>
            <Box component="section" data-testid="section" className="testimonial-section">
                <Box className="side-by-side-layout">
                    <Container maxWidth="lg" classes={{ root: 'sign-up-form' }}>
                        <CoachTrialConvertForm />
                    </Container>
                    <Box className="testimonial-container">
                        <Box className="spacer" />
                        <Box className="testimonial-card-frame">
                            <Box className="section-card testimonial-card">
                                <h4 className="testimonial-content">{testimonialDescription}</h4>
                                <h6 className="testimonial-author">{testimonialAuthor}</h6>
                            </Box>
                        </Box>
                        <PartnerLogoFooter />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
